export default "__VITE_ASSET__bb21d2f7__"